export const contact = {
  phone: "+41 76 430 56 58",
  whatsapp: "41764305658", // WhatsApp number without spaces or special characters
  email: "info.spendsfahrschule@gmail.com",
  address: {
    street: "Zürcherstrasse 46",
    city: "8400 Winterthur",
    full: "Zürcherstrasse 46, 8400 Winterthur"
  },
  openingHours: {
    weekdays: "07:00 - 12:00, 13:00 - 19:00",
    saturday: "07:00 - 12:00, 13:00 - 19:00",
    sunday: "07:00 - 12:00, 13:00 - 19:00",
    list: [
      "Montag - Sonntag: 07:00 - 12:00, 13:00 - 19:00"
    ]
  },
  map: {
    embedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2694.2883752589483!2d8.72111737679837!3d47.50043129789927!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x479a9999e3989157%3A0xdfc7d2938ec2a19c!2sZ%C3%BCrcherstrasse%2046%2C%208400%20Winterthur!5e0!3m2!1sen!2sch!4v1714065345678!5m2!1sen!2sch"
  }
}; 